function getNumeric(s: string): number {
  const val = Number.parseFloat(s)

  return Number.isNaN(val) ? 0 : val
}

export function getInteger(s: string): number {
  return Math.floor(getNumeric(s))
}
